module.exports = __webpack_public_path__ + "img/8_decent_work_and_economic_growth_color.8b7fb916.svg";